<template>
  <div
    class="crg-container"
    ref="crgContainer"
  />
</template>

<script setup>
import {useChemicalResistanceGuideHelper} from '~/composables/crg_helper.ts'
const {getHtml} = useChemicalResistanceGuideHelper()

const i18n = useI18n()
const crgContainer = ref(null)

onMounted(async () => {
  crgContainer.value.innerHTML = getHtml(i18n.locale.value)
  await loadScript('https://fst-resistanceguide.azurewebsites.net/js/main.js?v=1.0.2')
})

const loadScript = (src) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.onload = resolve
    script.onerror = reject
    document.head.appendChild(script)
  })
}
</script>

<style lang="scss">
@import "@/assets/scss/components/chemical-resistance-guide";
</style>
